
import { defineComponent } from 'vue'
import { IssueDistributionT } from '~/types/reportTypes'

export default defineComponent({
  name: 'DistributionSwitch',
  model: {
    prop: 'selectedFilter',
    event: 'change'
  },
  data() {
    return {
      IssueDistributionT
    }
  },
  props: {
    selectedFilter: {
      type: String,
      default: ''
    }
  },
  computed: {
    activeFilter: {
      get() {
        return this.selectedFilter
      },
      set(value: string) {
        this.$emit('change', value)
      }
    }
  }
})
